// extracted by mini-css-extract-plugin
export default {"row":"ShareReportModal_row__c+QkJ","danger":"ShareReportModal_danger__m07yi"};